import { useEffect, useCallback } from 'react';
import Axios from 'axios';

const useTrackSessionDuration = () => {
  const entryTime = Date.now(); // Capture entry time when the page is loaded

  // Function to calculate and send session duration when the user leaves the page
  const handleExit = useCallback(() => {
    const exitTime = Date.now(); // Capture exit time when the user leaves
    const sessionDuration = (exitTime - entryTime) / 1000; // Session duration in seconds

    // Send session duration to the backend for logging
    Axios.post('/api/logSessionDuration', { sessionDuration })
      .then(response => {
        console.log('Session duration logged successfully');
      })
      .catch(error => {
        console.error('Error logging session duration:', error);
      });
  }, [entryTime]);  // handleExit is stable and depends on entryTime

  // Add event listeners to detect page unload or user navigation
  useEffect(() => {
    window.addEventListener('beforeunload', handleExit); // When the page is closed or navigated away

    return () => {
      window.removeEventListener('beforeunload', handleExit);
    };
  }, [handleExit]); // handleExit is stable

  return null; // No UI needed, just the side effect of tracking session duration
};

export default useTrackSessionDuration;
